import { useCallback, useEffect, useState } from 'react';
import { document } from 'src/backend';
import useAuth from './useAuth';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';

export default function useDocuments() {
  const [types, setTypes] = useState([]);
  const [documents, setDocuments] = useState([]);
  const { user } = useAuth();
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation('translation', { keyPrefix: 'document' });
  useEffect(() => {
    document.getDocumentTypes().then((result) => setTypes(result));
  }, []);

  const fetchUserDocuments = useCallback(async () => {
    document
      .getUserDocuments(user?.id)
      .then((docs) => setDocuments(docs))
      .catch(() => {
        enqueueSnackbar(t('error-during-fetch'), { variant: 'error' });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return {
    documents,
    types,
    createDocument: async (data) => {
      return await document.createDocument(data);
    },
    updateDocument: async (id, data) => {
      await document.updateDocument(id, data);
      await fetchUserDocuments();
    },
    getMyDocuments: fetchUserDocuments,
    deleteDocument: async (id) => {
      await document.deleteDocument(id);
      await fetchUserDocuments();
    },
  };
}
